export default __webpack_public_path__ + "static/media/image.etecnovos-pvt-ltd.58552181.png";